import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { userIsAdmin } from "../../lib/adminImport";

/**
 * Renders children only for signed-in admins; others go to chat.
 */
export default function AdminOnlyRoute({ children, loginRedirect = "/" }) {
  const navigate = useNavigate();
  const { user, loading } = useAuth();

  useEffect(() => {
    if (loading) return;
    if (!user) {
      const path = window.location.pathname + window.location.search;
      navigate(`/login?redirect=${encodeURIComponent(path)}`, { replace: true });
      return;
    }
    if (!userIsAdmin(user)) {
      navigate(loginRedirect, { replace: true });
    }
  }, [user, loading, navigate, loginRedirect]);

  if (loading) {
    return (
      <div className="admin-only-route-loading">
        <p className="school-muted">Laden…</p>
      </div>
    );
  }

  if (!user || !userIsAdmin(user)) {
    return null;
  }

  return children;
}
